import gettext from '@sdk/lang/gettext';
import Row from '@sdk/components/ui/spacing/Row';
import Text14 from '@sdk/components/ui/typography/Text14';
import displayDuration from '@sdk/utils/displayDuration';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

type Props = {
  breakMinutes: number;
  isBefore?: boolean;
};

const BreakDuration = ({ breakMinutes, isBefore = false }: Props) => {
  if (!breakMinutes) {
    return null;
  }

  return (
    <Row>
      <Text14
        themeColor={isBefore ? ThemeColorType.iconGray : ThemeColorType.gray}
        strikethrough={isBefore}>
        {gettext('%(breakMinutes)s break', {
          breakMinutes: displayDuration(breakMinutes),
        })}
      </Text14>
    </Row>
  );
};

export default BreakDuration;
